import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

const StyledContainerDiv = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  height: '168px',
  justifyContent: 'center',
  width: '100%',
});

export function EmptyTablePlaceholder() {
  const { t } = useTranslation();

  return (
    <StyledContainerDiv>
      <Typography variant="h3">{t('No data available')}</Typography>
      <Box
        sx={{
          marginTop: '10px',
        }}
      >
        <Typography variant="body1">{t('Created entries will be shown here')}</Typography>
      </Box>
    </StyledContainerDiv>
  );
}
